import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';
import { classNames } from 'utils';
import './formItem.scss';

const { Item: AntFormItem } = Form;

const LabelBlock = ({ label }) => <span className="required_mark">{label}</span>;

const FormItem = React.forwardRef(
  (
    {
      children,
      fontType = 'bold',
      errorFieldSwitchable = false,
      colon = false,
      label,
      rules,
      ...rest
    },
    ref,
  ) => {
    const errorField = errorFieldSwitchable ? 'error_field_grow_up' : 'error_field_fixed';

    const requiredMark = rules?.find((rule) => rule.required === true);

    return (
      <>
        <AntFormItem
          {...rest}
          colon={colon}
          label={requiredMark ? <LabelBlock label={label} /> : label}
          rules={rules}
          ref={ref}
          className={classNames('ui-kit-form-item', fontType, errorField)}
        >
          {children}
        </AntFormItem>
      </>
    );
  },
);

LabelBlock.propTypes = {
  label: PropTypes.string,
};

FormItem.propTypes = {
  fontType: PropTypes.string,
  colon: PropTypes.bool,
  children: PropTypes.node,
  errorFieldSwitchable: PropTypes.bool,
  label: PropTypes.string,
  rules: PropTypes.array,
};

export default FormItem;
